// Platform vocabulary for device-aware FAQ entries.
//
// Keys mirror what utils/deviceUa.js parses from device user agents, so the
// Lunova app can read a category's `metadata.platforms` and auto-show only the
// FAQ entries that apply to the device it's running on. An empty (or absent)
// platform list means the category is universal — it shows on every platform.

export const FAQ_PLATFORMS = [
  { key: "firetv", label: "Fire TV" },
  { key: "androidtv", label: "Android TV" },
  { key: "tvos", label: "Apple TV" },
  { key: "android", label: "Mobile (Android)" },
  { key: "ios", label: "iOS" },
];

export const platformLabel = (key) =>
  FAQ_PLATFORMS.find((p) => p.key === key)?.label || key;

// Tailwind pill classes per platform, matching the low-opacity ring-pill style
// used elsewhere in the dashboard (see AppMessages.js severity/origin badges).
export const PLATFORM_PILL = {
  firetv:
    "bg-orange-500/10 text-orange-600 dark:text-orange-400 ring-1 ring-inset ring-orange-500/20",
  androidtv:
    "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 ring-1 ring-inset ring-emerald-500/20",
  tvos: "bg-rose-500/10 text-rose-600 dark:text-rose-400 ring-1 ring-inset ring-rose-500/20",
  android:
    "bg-sky-500/10 text-sky-600 dark:text-sky-400 ring-1 ring-inset ring-sky-500/20",
  ios: "bg-violet-500/10 text-violet-600 dark:text-violet-400 ring-1 ring-inset ring-violet-500/20",
};

// Whether a category (by its platform tags) should be shown under a given
// filter. Empty tags = universal, so it matches every specific platform too.
export const categoryMatchesPlatform = (platforms, filter) =>
  filter === "all" ||
  !platforms ||
  platforms.length === 0 ||
  platforms.includes(filter);
